import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var SpecialEventDecoration = function SpecialEventDecoration() {
  return import(
  /* webpackMode: "eager" */
  '~/components/atoms/Product/Decorations/SpecialEventDecoration.vue');
};

export default {
  name: 'TheSpecialEventSection',
  components: {
    SpecialEventDecoration: SpecialEventDecoration
  },
  props: {
    special: {
      type: Object,
      required: true
    }
  }
};